/** Registered Colyseus room name. */
export const ROOM_NAME = "fortress";
/**
 * App release version — bump by 1 on every deploy that should prompt open
 * clients to reload. The single source of truth for both sides: the server
 * reads it at runtime (`serverConfig.appVersion`, advertised via
 * `GET /app-state`), while the client bakes it into its bundle at build time.
 * After a deploy, a still-open tab is running the OLD bundle: it polls
 * `/app-state`, sees a HIGHER server version, and shows the sticky
 * "new version — refresh" banner.
 */
export const APP_VERSION = 1;
/** Default port the Colyseus server listens on. */
export const DEFAULT_SERVER_PORT = 2567;
/**
 * Deployed environments and their public hostnames — the single source of
 * truth for the domain scheme. clientConfig.ts (client → API routing) and
 * serverConfig.ts (CORS allowlist) both derive from these; the cache-purge
 * DOMAIN in .github/workflows/deploy.yml mirrors `clientHostForEnv` by hand
 * (a workflow can't import TypeScript).
 */
export const DEPLOY_ENVS = ["dev", "test", "prod"];
export const BASE_DOMAIN = "fortressascent.com";
/** Custom domain the env's client is served from. */
export function clientHostForEnv(env) {
    return env === "prod" ? `play.${BASE_DOMAIN}` : `${env}.${BASE_DOMAIN}`;
}
/** Cloudflare Pages default host for the env's client project. */
export function pagesHostForEnv(env) {
    return `fortress-client-${env}.pages.dev`;
}
/** Cloud Run API host (Colyseus WebSocket + auth HTTP) for the env. */
export function apiHostForEnv(env) {
    return env === "prod" ? `api.${BASE_DOMAIN}` : `api.${env}.${BASE_DOMAIN}`;
}
/**
 * Board radius in hex rings from the centre. The board is a regular hexagon
 * containing every hex with `cubeRingIndex <= BOARD_RADIUS`; players move
 * between the corners (nodes) of those hexes. See coords/ and CLAUDE.md.
 *
 * Radius 15 yields 6·16² = 1536 nodes. The outermost row (16) is the forest
 * perimeter; at this radius it is a single lattice row wide, while every inner
 * zone keeps its tile structure (summit/crag/ridgeline/foothill). Building
 * Ranges stay balanced against the resulting node density.
 */
export const BOARD_RADIUS = 15;
//# sourceMappingURL=constants.js.map